<template>
  <div class="actions">
    <c-button
      v-if="record.calcId !== null && record.calcId !== undefined"
      v-b-popover.html="{
        container: '#app',
        trigger: 'hover blur',
        content: 'Перейти в сохраненный расчет',
        placement: 'top',
      }"
      size="iconic"
      icon="calculate"
      @click="openCalc(record.calcId)"
    />
  </div>
</template>

<script>
import Button from "@/components/controls2/Button";

export default {
  name: "data-table-personal-transactions-actions",
  components: {
    "c-button": Button,
  },
  props: ["record"],
  methods: {
    openCalc(calcId) {
      const routeData = this.$router.resolve({ name: "save-calculation-production", query: { calc_id: calcId } });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.actions {
  padding: 10px;
  min-width: 40px;
  max-width: 40px;
}
</style>
